import { SVGProps } from 'react';
import { Sun } from './icons/Sun';
import { Moon } from './icons/Moon';
import { LightBulb } from './icons/LightBulb';
import { Fire } from './icons/Fire';
import { Direction } from './icons/Direction';
import { Group } from './icons/Group';
import { Sunrise } from './icons/Sunrise';
import { Sunset } from './icons/Sunset';
import { Instagram } from './icons/Instagram';
import { TimelessColours } from './icons/TimelessColours';
import { Durable } from './icons/Durable';
import { DepthOfColour } from './icons/DepthOfColour';
import { Finish } from './icons/Finish';
import { Dog } from './icons/Dog';

export interface CustomIconProps extends SVGProps<SVGSVGElement> {
  name: keyof typeof icons;
}

const icons = {
  Sun,
  LightBulb,
  Fire,
  Moon,
  Direction,
  Group,
  Sunrise,
  Sunset,
  Instagram,
  TimelessColours,
  Finish,
  Durable,
  DepthOfColour,
  Dog,
} as const;

export const CustomIcon = (props: CustomIconProps) => icons[props.name](props) || null;
